import Surgeries from "@/views/surgeries/index.vue";
import Surgery from "@/views/surgeries/surgery/index.vue";
import Details from "@/views/surgeries/surgery/details.vue";
import Preoperative from "@/views/surgeries/surgery/preoperative.vue";
import Intraoperative from "@/views/surgeries/surgery/intraoperative.vue";
import Postoperative from "@/views/surgeries/surgery/postoperative.vue";

export default [
  {
    path: "cirurgia",
    name: "Cirurgia",
    component: Surgeries,
  },
  {
    path: "cirurgia/:surgeryId",
    name: "Editar Cirurgia",
    props: true,
    component: Surgery,
    redirect: {
      path: "cirurgia/:surgeryId/detalhes",
    },
    children: [
      {
        path: "detalhes",
        name: "Detalhes da Cirurgia",
        component: Details,
      },
      {
        path: "pre-operatorio",
        name: "Pré-operatório da Cirurgia",
        component: Preoperative,
      },
      {
        path: "intra-operatorio",
        name: "Intra-operatório da Cirurgia",
        component: Intraoperative,
      },
      {
        path: "pos-operatorio",
        name: "Pós-operatório da Cirurgia",
        component: Postoperative,
      },
    ],
  },
];
